import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export const METRIC_TOOLTIP_CARD_CLASSES =
  'rounded-lg border bg-background px-3 py-2 shadow-lg text-foreground';

export const MetricTooltipCard = ({
  title,
  children,
  className,
}: {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn(METRIC_TOOLTIP_CARD_CLASSES, className)}>
    {title && <p className="mb-3 text-sm leading-none font-medium">{title}</p>}
    <div className="space-y-1 text-xs leading-4 font-normal">{children}</div>
  </div>
);

export const MetricTooltipRow = ({
  label,
  value,
  color,
}: {
  label: ReactNode;
  value: ReactNode;
  color?: string;
}) => (
  <div className="flex items-center justify-between gap-6">
    <span className="flex items-center gap-2 text-foreground-muted">
      {color && (
        <span
          aria-hidden
          className="inline-block h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
      )}
      {label}
    </span>
    <span className="font-semibold">{value}</span>
  </div>
);

export const MetricTooltipSectionLabel = ({ children }: { children: ReactNode }) => (
  <p className="mt-2 text-xs leading-4 font-medium text-foreground-muted">{children}</p>
);
